import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full">
      <Box
        sx={(theme) => ({
          position: "relative",
          zIndex: 60,
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
        })}
      >
        <Box className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          {/* 左：リンク */}
          <div className="flex gap-6 text-sm">
            <Link to="/" className="opacity-90 hover:opacity-100">TOP</Link>
            <Link to="/company" className="opacity-90 hover:opacity-100">運営会社</Link>
            <Link to="/terms" className="opacity-90 hover:opacity-100">利用規約</Link>
            <Link to="/privacy" className="opacity-90 hover:opacity-100">プライバシーポリシー</Link>
          </div>

          {/* 右：コピーライト */}
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            Copyright © 2025 Afrofair internet. All Rights Reserved.
          </Typography>
        </Box>
      </Box>
    </footer>
  );
}
